import PropTypes from "prop-types";
import React from "react";
import { Alert, useMantineTheme } from "@mantine/core";
import {
  IconInfoCircle,
  IconAlertSquareRounded,
  IconAlertTriangle,
} from "@tabler/icons-react";

import { useStylesInfoBanner } from "../utils/mantine/useStylesInfoBanner";

export const InfoBanner = ({
  children,
  title = "",
  type = "",
  className = "",
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  let colorAlert = theme.infoBanner.info.color;
  let iconAlert = <IconInfoCircle />;
  let colorAlertBg = theme.infoBanner.info.bg;

  if (type === "warning") {
    colorAlert = theme.infoBanner.warning.color;
    colorAlertBg = theme.infoBanner.warning.bg;
    iconAlert = <IconAlertSquareRounded />;
  } else if (type === "error") {
    colorAlert = theme.infoBanner.error.color;
    colorAlertBg = theme.infoBanner.error.bg;
    iconAlert = <IconAlertTriangle />;
  }

  const { classes } = useStylesInfoBanner({ colorAlertBg });

  return (
    <Alert
      variant="light"
      className={`${classes.banner} ${className}`}
      color={colorAlert}
      title={title}
      icon={iconAlert}
    >
      {children}
    </Alert>
  );
};

InfoBanner.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};
